import React, { useEffect } from 'react';
import Header from '#/components/Form/Header/Header';
import { useParams } from 'react-router-dom';
import ApiManager from '#/services/api/ApiManager';
import { spotifyApiConfig } from '#/utils/constants';
import useProtectedSpotify from '#/hooks/useProtectedAxios';
import { useDispatch, useSelector } from 'react-redux';
import { IArtistAlbums } from '#/types/API/artists';
import { TRootState } from '#/redux/store';
import PreviewLayout from '#/components/Layout/PreviewLayout/PreviewLayout';
import LoadingPage from '#/components/Layout/LoadingPage/LoadingPage';
import {
  createActionArtistAppearsOnError,
  createActionArtistAppearsOnReset,
  createActionArtistAppearsOnSetApearsOn,
  createActionArtistAppearsOnStartLoading,
  createActionArtistAppearsOnStopLoading,
} from '#/redux/actions/artistAppearsOn';
import AlbumPreview from '#/components/Layout/AlbumPreview/AlbumPreview';

const AppearsOn = () => {
  const { id } = useParams();

  const protectedSpotify = useProtectedSpotify();

  const dispatch = useDispatch();

  const apearsOnSlice = useSelector(
    (state: TRootState) => state.artistAppearsOn
  );

  const { appearsOn, _loading, _error } = apearsOnSlice;

  useEffect(() => {
    const getArtistAppearsOn = async () => {
      if (id) {
        dispatch(createActionArtistAppearsOnStartLoading());
        const apiMannager = new ApiManager(spotifyApiConfig, protectedSpotify);

        const responseApearsOn = await apiMannager.getEntity<IArtistAlbums>(
          'artists',
          `${id}/albums`,
          { include_groups: 'appears_on' }
        );

        if ('error' in responseApearsOn) {
          // TODO: handle error
          dispatch(createActionArtistAppearsOnError());
        } else {
          dispatch(
            createActionArtistAppearsOnSetApearsOn(responseApearsOn.data)
          );

          dispatch(createActionArtistAppearsOnStopLoading());
        }
      }
    };

    getArtistAppearsOn();
  }, [dispatch, id, protectedSpotify]);

  useEffect(() => {
    return () => {
      dispatch(createActionArtistAppearsOnReset());
    };
  }, [dispatch]);

  return (
    <>
      {_loading || _error ? (
        <LoadingPage />
      ) : (
        <div className="p-theme-page-padding">
          <Header
            className=" text-2xl font-bold tracking-tighter mt-4 mb-5"
            type="h1"
          >
            Appears On
          </Header>
          <PreviewLayout>
            {appearsOn?.items.map((album) => {
              return (
                <AlbumPreview
                  uri={album.uri}
                  key={album.id}
                  albumName={album.name}
                  artistName={album.artists
                    .map((artist) => artist.name)
                    .join(', ')}
                  image={album.images[0].url}
                />
              );
            })}
          </PreviewLayout>
        </div>
      )}
    </>
  );
};

export default AppearsOn;
